import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { CHECKOUT_URL } from "../config";
import { EASE } from "./Shared";

export default function StickyBar() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > window.innerHeight * 0.9);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ y: 90 }}
          animate={{ y: 0 }}
          exit={{ y: 90 }}
          transition={{ duration: 0.45, ease: EASE }}
          className="fixed bottom-0 inset-x-0 z-50 lg:hidden border-t border-cream/15 bg-ink/85 backdrop-blur-xl"
          data-testid="sticky-bottom-bar"
        >
          <div className="flex items-center justify-between gap-4 px-4 py-3">
            <div>
              <p className="font-display font-extrabold uppercase tracking-tight text-sm leading-none">
                BLUEPRINT<span className="text-lime">™</span>
              </p>
              <p className="font-mono text-[9px] tracking-[0.2em] uppercase text-fog mt-1">
                Course + books + community + bonus book
              </p>
            </div>
            <a
              data-testid="sticky-bottom-cta-button"
              href={CHECKOUT_URL}
              className="group inline-flex items-center gap-1.5 bg-lime text-ink font-display font-bold uppercase tracking-wide text-xs px-5 py-3 transition-colors duration-300 active:bg-cream"
            >
              Get access — $111
              <ArrowUpRight size={14} strokeWidth={2.5} />
            </a>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
